export type CountryCodeOption = {
  label: string;
  name: string;
  value: string;
  dialCode: string;
};

/** US-only dial code for profile mobile number entry. */
export const US_COUNTRY_CODE_OPTION: CountryCodeOption = {
  label: "US +1",
  name: "United States",
  value: "US",
  dialCode: "+1",
};

export const COUNTRY_CODE_OPTIONS: CountryCodeOption[] = [
  US_COUNTRY_CODE_OPTION,
];

export const DEFAULT_COUNTRY_CODE = US_COUNTRY_CODE_OPTION.value;
export const US_DIAL_CODE = US_COUNTRY_CODE_OPTION.dialCode;
